export class InternshipChartsModel {
    studentStatusChart: any = {};
}